import React, { MouseEventHandler, PropsWithChildren } from 'react';
import theme from './SettingsSection.module.scss';
import { classnames } from '@/utils/html';

interface SettingsSectionListItemProps extends PropsWithChildren {
    onClick?: MouseEventHandler<HTMLLIElement>;
    active?: boolean;
}

const SettingsSectionListItem: React.FC<SettingsSectionListItemProps> = ({ onClick, active, children }) => {
    return (
        <li className={classnames({ [theme.active]: active })} onClick={onClick}>
            {children}
        </li>
    );
};

export default SettingsSectionListItem;
